<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :model="queryParams" size="small" v-show="showSearch" label-width="90px">
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="委托单编号" prop="entrustNum">
                <el-input v-model="queryParams.entrustNum" placeholder="请输入委托单编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="检测人" prop="testEmployeeName">
                <el-input v-model="queryParams.testEmployeeName" placeholder="请输入检测人" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="设备名称" prop="eqpTempName">
                <el-input v-model="queryParams.eqpTempName" placeholder="请输入设备名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="识别码" prop="oidno">
                <el-input v-model="queryParams.oidno" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="检测日期" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                clearable @change="handleQuery" style="width:100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="设备代码" prop="eqpStationCod">
                <el-input v-model="queryParams.eqpStationCod" placeholder="请输入设备代码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="产品编号" prop="factoryCod">
                <el-input v-model="queryParams.factoryCod" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex"> 
            <el-col :span="5">
              <el-form-item label="状态" prop="statusFilter">
                <el-select v-model="queryParams.statusFilter" placeholder="请选择状态" @change="handleQuery">
                  <el-option label="待提交" :value="3"></el-option>
                  <el-option label="待审核后未签名" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleIssue="handleIssue" @handleBatchReturn="handleBatchReturn" @handleSignClick="handleSignClick" />
          </div>
        </el-form>

        <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading" row-key="id"
                  height="500" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" fixed="left" align="left" />
          <el-table-column type="index" label="序号" width="55" fixed="left" align="left" />
          <el-table-column label="有无签名" align="left" prop="signStatus" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.signStatus == 1 ? 'success' : 'danger'">
                {{ scope.row.signStatus == 1 ? '有' : '无' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="识别码" align="left" prop="oidno" min-width="140" show-overflow-tooltip />
          <el-table-column label="产品编号" align="left" prop="factoryCod" min-width="140" show-overflow-tooltip />
          <el-table-column label="检测人" align="left" prop="testEmployeeName" min-width="100" show-overflow-tooltip />
          <el-table-column label="设备名称" align="left" prop="eqpTempName" min-width="140" show-overflow-tooltip />
          <el-table-column label="设备代码" align="left" prop="eqpStationCod" min-width="120" show-overflow-tooltip />
          <el-table-column label="内部编号" align="left" prop="eqpInnerCod" min-width="120" show-overflow-tooltip />
          <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip />
          <el-table-column label="小区名称" align="left" prop="houseName" min-width="140" show-overflow-tooltip />
          <el-table-column label="检测日期" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip />
          <el-table-column label="整改日期" align="left" prop="itemConfirmTime" min-width="160" show-overflow-tooltip />
          <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip />
          <el-table-column label="有无整改项" align="left" prop="memoState" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.memoState == 0 ? 'success' : 'danger'">
                {{ scope.row.memoState == 2 ? '无' : '有' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="委托单编号" align="left" prop="entrustNum" min-width="260" show-overflow-tooltip />
          <el-table-column label="操作" align="left" width="420" fixed="right">
            <template slot-scope="scope">
              <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleRectificationDetail="handleRectificationDetail(scope.row)"
                                   @handleMemoDetail="handleMemoDetail(scope.row)" @handleEquipmentInfo="handleEquipmentInfo(scope.row)" @handlePDF="handlePDF(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;" />
      </el-col>
    </el-row>

    <Rectification ref="rectification" />
    <EquipmentConfirmDialog ref="equipmentConfirmDialog" />

    <el-dialog title="签名二维码" :visible.sync="qrDialogVisible" width="360px" :close-on-click-modal="false" @closed="resetQrDialog">
      <div
        v-loading="qrLoading"
        element-loading-text="正在生成二维码..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:248px;"
      >
        <img
          v-if="qrImageUrl"
          :src="qrImageUrl"
          alt="二维码"
          style="width:240px;height:240px;border:1px solid #eee;padding:4px;border-radius:4px;"
          @load="handleQrImageLoad"
          @error="handleQrImageError"
        />
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>

    <el-dialog title="PDF预览" :visible.sync="pdfPreviewVisible" width="90%" :close-on-click-modal="false">
      <PdfImgViewer v-if="pdfPreviewVisible && pdfFileName" :fileName="pdfFileName" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量退回报告" :visible.sync="batchReturnDialogVisible" width="600px" :before-close="closeBatchReturnDialog">
      <el-form :model="batchReturnForm" ref="batchReturnForm" label-width="120px" :rules="batchReturnRules">
        <el-form-item label="选中数量">
          <el-input :value="multipleSelection.length + ' 条'" disabled />
        </el-form-item>
        <el-form-item label="退回原因" prop="returnReason">
          <el-input v-model="batchReturnForm.returnReason" type="textarea" :rows="4" placeholder="请输入退回原因" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBatchReturnDialog">取 消</el-button>
        <el-button type="danger" @click="confirmBatchReturn" :loading="batchReturnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Rectification from '../rectificationItem/rectification.vue';
import EquipmentConfirmDialog from '../OriginalManagement/EquipmentConfirmDialog.vue';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import { queryPendingSubmitReportList, submitPendingReportBatch, batchBackPendingReport, previewTestDataPdf } from '@/api/contract/contract';

export default {
  name: 'PendingReview',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    Rectification,
    EquipmentConfirmDialog,
    PdfImgViewer
  },
  data () {
    return {
      showSearch: true,
      tableData: [],
      loading: false,
      total: 0,
      multipleSelection: [],
      queryParams: {
        currPage: 1,
        pageSize: 200,
        entrustNum: undefined,
        testEmployeeName: undefined,
        eqpTempName: undefined,
        compNames: undefined,
        oidno: undefined,
        usingUnit: undefined,
        houseName: undefined,
        testDateRange: undefined,
        eqpStationCod: undefined,
        factoryCod: undefined,
        statusFilter: 3
      },
      qrDialogVisible: false,
      qrImageUrl: '',
      qrLoading: false,
      pdfPreviewVisible: false,
      pdfFileName: '',
      batchReturnDialogVisible: false,
      batchReturnForm: {
        returnReason: ''
      },
      batchReturnRules: {
        returnReason: [
          { required: true, message: '请输入退回原因', trigger: 'blur' }
        ]
      },
      batchReturnLoading: false
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 查询待提交报告列表
    getList () {
      this.loading = true;
      const payload = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
        entrustNum: this.queryParams.entrustNum,
        testEmployeeName: this.queryParams.testEmployeeName,
        eqpTempName: this.queryParams.eqpTempName,
        compNames: this.queryParams.compNames,
        oidno: this.queryParams.oidno,
        usingUnit: this.queryParams.usingUnit,
        houseName: this.queryParams.houseName,
        testDateRange: this.queryParams.testDateRange,
        eqpStationCod: this.queryParams.eqpStationCod,
        factoryCod: this.queryParams.factoryCod,
        statusFilter: this.queryParams.statusFilter
      };

      queryPendingSubmitReportList(payload).then(res => {
        this.loading = false;
        if (res && res.retCode === 'ok') {
          const pageData = res.additionalData || {};
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = pageData;
          this.tableData = records.map((item, index) => ({
            ...item,
            id: item.id || `${item.entrustNum || ''}_${index}`
          }));
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
          return;
        }
        this.$message.error((res && res.retMsg) || '获取待提交报告列表失败');
      }).catch(error => {
        this.loading = false;
        console.error('获取待提交报告列表失败:', error);
        this.$message.error('获取待提交报告列表失败');
      });
    },
    // 点击查询，重置到第一页后重新拉取数据
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置查询条件并刷新列表
    resetQuery () {
      this.queryParams = {
        currPage: 1,
        pageSize: 200,
        entrustNum: undefined,
        testEmployeeName: undefined,
        eqpTempName: undefined,
        compNames: undefined,
        oidno: undefined,
        usingUnit: undefined,
        houseName: undefined,
        testDateRange: undefined,
        eqpStationCod: undefined,
        factoryCod: undefined,
        statusFilter: '3'
      };
      this.getList();
    },
    // 表格勾选变化时，缓存当前勾选项
    handleSelectionChange (val) {
      this.multipleSelection = Array.isArray(val) ? val : [];
    },
    // 点击签名
    handleSignClick () {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选需要签名的记录');
        return;
      }
      // 收集勾选的 entrustNum
      const entrustNums = this.multipleSelection
        .map(item => item.entrustNum)
        .filter(v => !!v);
      if (entrustNums.length === 0) {
        this.$message.warning('勾选的数据缺少委托单编号');
        return;
      }
      // 先清空历史二维码，避免二次打开时短暂显示旧图
      this.qrImageUrl = '';
      this.qrLoading = true;
      this.qrDialogVisible = true;
      // 构建最终跳转地址，并在下一帧再赋值新二维码地址
      const finalUrl = this.buildSignUrl(entrustNums);
      this.$nextTick(() => {
        this.qrImageUrl = this.buildQrImageUrl(finalUrl);
      });
    },
    // 二维码图片加载完成，关闭遮罩
    handleQrImageLoad () {
      this.qrLoading = false;
    },
    // 二维码图片加载失败
    handleQrImageError () {
      this.qrLoading = false;
      this.$message.error('二维码生成失败，请重试');
    },
    // 关闭弹窗后重置二维码状态，避免历史遗留
    resetQrDialog () {
      this.qrImageUrl = '';
      this.qrLoading = false;
    },
    // 构建签名链接：https://www.tljcgroup.cn?entrustNums=WT1%2CWT2
    buildSignUrl (entrustNums) {
      const joined = entrustNums.join(',');
      const encoded = encodeURIComponent(joined);
      return `https://www.tljcgroup.cn?entrustNums=${encoded}`;
    },
    // 生成二维码图片地址（使用在线二维码服务）
    buildQrImageUrl (text) {
      const encodedData = encodeURIComponent(text);
      return `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodedData}`;
    },
    // 批量提交
    handleIssue () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选要提交的数据');
        return;
      }
      const hasUnsignedData = this.multipleSelection.some(item => Number(item.signStatus) !== 1);
      if (hasUnsignedData) {
        this.$message.warning('有数据未签名，请签名后重试');
        return;
      }
      const submitList = this.multipleSelection
        .filter(item => item && item.entrustNum)
        .map(item => ({
          entrustNum: item.entrustNum,
          optType: 'Test'
        }));
      if (!submitList.length) {
        this.$message.warning('勾选数据缺少委托单编号');
        return;
      }

      this.loading = true;
      submitPendingReportBatch(submitList).then(res => {
        this.loading = false;
        if (res && res.retCode === 'ok') {
          this.$message.success(res.retMsg || '批量提交成功');
          this.getList();
          return;
        }
        this.$message.error((res && res.retMsg) || '批量提交失败');
      }).catch(error => {
        this.loading = false;
        console.error('批量提交失败:', error);
        this.$message.error('批量提交失败');
      });
    },
    // 批量退回
    handleBatchReturn () {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选要退回的数据');
        return;
      }
      this.batchReturnForm.returnReason = '';
      this.batchReturnDialogVisible = true;
    },
    // 关闭批量退回对话框
    closeBatchReturnDialog () {
      this.batchReturnDialogVisible = false;
      this.$refs.batchReturnForm && this.$refs.batchReturnForm.resetFields();
    },
    // 确认批量退回
    confirmBatchReturn () {
      this.$refs.batchReturnForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const entrustNums = this.multipleSelection.map(item => item.entrustNum).filter(Boolean);
        if (!entrustNums.length) {
          this.$message.warning('勾选数据缺少委托单编号');
          return;
        }
        this.batchReturnLoading = true;
        batchBackPendingReport(entrustNums).then(res => {
          this.batchReturnLoading = false;
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg || '批量退回成功');
            this.closeBatchReturnDialog();
            this.getList();
            return;
          }
          this.$message.error((res && res.retMsg) || '批量退回失败');
        }).catch(error => {
          this.batchReturnLoading = false;
          console.error('批量退回失败:', error);
          this.$message.error('批量退回失败');
        });
      });
    },
    // 打开整改详情弹窗
    handleRectificationDetail (row) {
      this.$refs.rectification && this.$refs.rectification.openDialog(row, { mode: 'view' });
    },
    // 打开备忘录PDF预览
    handleMemoDetail (row) {
      if (!row.memoFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.pdfFileName = row.memoFileUUID;
      this.pdfPreviewVisible = true;
    },
    // 打开设备信息弹窗（只读）
    handleEquipmentInfo (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row, 'view');
    },
    // 查看记录/报告，先让用户选择预览类型
    handlePDF (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$confirm('请选择要查看的内容：', '选择打印类型', {
        distinguishCancelAndClose: true,
        confirmButtonText: '原始记录',
        cancelButtonText: '报告',
        type: 'info'
      }).then(() => {
        this.callPreviewAPI(row.entrustNum, 1);
      }).catch(action => {
        if (action === 'cancel') {
          this.callPreviewAPI(row.entrustNum, 0);
        }
      });
    },
    // 调用预览接口并打开PDF弹窗
    callPreviewAPI (entrustNum, type) {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      previewTestDataPdf({ entrustNums: [entrustNum], type }).then(response => {
        loading.close();
        if (response && response.retCode === 'ok' && response.additionalData) {
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        loading.close();
        console.error('查看PDF失败:', error);
        this.$message.error('查看PDF失败');
      });
    },
    // 分页大小变更后重新查询
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页变更后重新查询
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 控制行按钮禁用逻辑
    getDisabledButtons (row) {
      if (row.memoState != 1 && row.memoState != 0) {
        return ['handleRectificationDetail'];
      }
      return [];
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
